import localStore from './localStore.js';

function isLoggedIn() {
  var authToken = localStore.get('authToken');
  if (!authToken) {
    logout();
    return false;
  }
  return true;
}

function logout() {
  localStore.clear('authToken');
  localStore.clear('userData');
  localStore.clear('retailer');
  clearPPPIds();
}

function setPPPIds(sellerID, storeID) {
  localStore.put('pppSellerID', sellerID);
  localStore.put('pppStoreID', storeID);
}

function getPPPIds() {
  return {
    sellerID: localStore.get('pppSellerID'),
    storeID: localStore.get('pppStoreID')
  };
}

function getPPPIdsFromURL() {
  const [, sellerID = null, storeID = null] = window.location.pathname.split(
    '/'
  );
  return { sellerID, storeID };
}

function clearPPPIds() {
  localStore.clear('pppSellerID');
  localStore.clear('pppStoreID');
}

function getToken() {
  var authToken = localStore.get('authToken');

  if (authToken) return authToken;
  return null;
}

function set(data) {
  return localStore.put('userData', data);
}

function get() {
  const data = localStore.get('userData');
  if (data) {
    return JSON.parse(data);
  } else {
    return null;
  }
}

export default {
  isLoggedIn,
  logout,
  getToken,
  get,
  set,
  setPPPIds,
  getPPPIds,
  getPPPIdsFromURL,
  clearPPPIds
};
